module.exports = __webpack_public_path__ + "static/media/lianjie.6ed587fe.svg";